import { NavLink, Outlet, useLocation } from "react-router-dom";
import { HealthStatus } from "./HealthStatus";

const links = [
  { to: "/stations", label: "Stations", match: (p: string) => p.startsWith("/stations") },
  { to: "/trains", label: "Trains", match: (p: string) => p === "/trains" || /^\/trains\/\d+/.test(p) },
  { to: "/trains/live", label: "Live board", match: (p: string) => p === "/trains/live" },
  { to: "/routes", label: "Find trains", match: (p: string) => p.startsWith("/routes") },
  { to: "/map", label: "Live map", match: (p: string) => p === "/map" },
  { to: "/track", label: "Track train", match: (p: string) => p === "/track" || /^\/map\/\d+/.test(p) },
];

export function Layout() {
  const { pathname } = useLocation();

  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand">Train Tracker</div>
        <nav className="nav">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className={() => (l.match(pathname) ? "nav-link active" : "nav-link")}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <HealthStatus />
      </header>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
